(() => {
  'use strict';
  if (customElements.get('ss-man-style-picker')) return;
  let pendingFocus = false;
  const retained = new Map();
  let retainedShipping = null;
  const isMan = picker => picker && picker.classList.contains('ss-man-variant-picker');

  function sectionFor(picker) { return document.getElementById('MainProduct-' + picker.dataset.section); }
  function savePersonalization(section) {
    retainedShipping = section.querySelector('[id*="synctrack_edd_omega_estimated_shipping"]') || retainedShipping;
    section.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach(input => {
      retained.set(input.name, {value: input.value, checked: input.checked});
    });
  }
  function sync(picker) {
    if (!isMan(picker)) return;
    const section = sectionFor(picker);
    if (!section) return;
    section.classList.add('ss-man-product');
    section.classList.remove('ss-man-busy');
    const shipping = section.querySelector('[id*="synctrack_edd_omega_estimated_shipping"]');
    if (retainedShipping && shipping && shipping !== retainedShipping) shipping.replaceWith(retainedShipping);
    picker.querySelectorAll('.product-form__input--option-shape .ss-variant-option-text').forEach(node => {
      node.textContent = node.textContent.replace(/^M-/, '');
    });
    retained.forEach((state, name) => {
      section.querySelectorAll('input,textarea').forEach(input => {
        if (input.name === name) {
          input.value = state.value; input.checked = state.checked;
          input.dispatchEvent(new Event('input', {bubbles:true}));
        }
      });
    });
    const selected = picker.querySelector('.ss-man-radio:checked');
    const gallery = document.getElementById('MediaGallery-' + picker.dataset.section);
    if (selected?.dataset.mediaId && gallery?.setActiveMedia) {
      const mediaId = picker.dataset.section + '-' + selected.dataset.mediaId;
      const slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide && !slide.classList.contains('is-active')) gallery.setActiveMedia(mediaId, true);
    }
    if (pendingFocus) {
      pendingFocus = false;
      requestAnimationFrame(() => picker.querySelector('.ss-man-trigger')?.focus({preventScroll:true}));
    }
  }

  class ManStylePicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.trigger = this.querySelector('.ss-man-trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog) return;
      this.ready = true;
      this.picker = this.closest('.ss-man-variant-picker');
      this.initialOptions = Array.from(this.picker.querySelectorAll('input[type=radio]:checked')).map(input => ({name:input.name,value:input.value}));
      this.section = sectionFor(this.picker);
      this.filter = 'all';
      this.search = this.querySelector('input[type=search]');
      this.feedback = this.querySelector('.ss-man-feedback');
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('.ss-man-close').addEventListener('click', () => this.close());
      this.dialog.addEventListener('close', () => this.unlock());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      });
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        this.filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.filterStyles();
      }));
      this.search.addEventListener('input', () => this.filterStyles());
      this.querySelectorAll('.ss-man-card').forEach(label => label.addEventListener('click', () => {
        if (document.getElementById(label.htmlFor).checked) this.close();
      }));
      this.observer = new MutationObserver(() => this.updateBusy());
      this.observer.observe(this.picker, {attributes:true, attributeFilter:['aria-busy']});
      this.section.classList.add('ss-man-product');
      requestAnimationFrame(() => sync(this.picker));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.close(false);
    }
    open() {
      if (this.picker.getAttribute('aria-busy') === 'true') return;
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      this.querySelector('.ss-man-close').focus({preventScroll:true});
      const selected = this.querySelector('.ss-man-radio:checked')?.closest('.ss-man-choice');
      if (selected && !selected.hidden) {
        const scroller = this.querySelector('.ss-man-scroll');
        scroller.scrollTop = selected.offsetTop - scroller.offsetTop - 4;
      }
    }
    close(focus = true) {
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
      if (focus && this.isConnected) this.trigger.focus({preventScroll:true});
    }
    unlock() {
      if (this.locked) document.documentElement.style.overflow = this.oldOverflow;
      this.locked = false;
      this.trigger?.setAttribute('aria-expanded', 'false');
    }
    filterStyles() {
      const terms = this.search.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      this.querySelectorAll('.ss-man-choice').forEach(choice => {
        const visible = (this.filter === 'all' || choice.dataset.facial === this.filter) && terms.every(term => choice.dataset.search.includes(term));
        choice.hidden = !visible;
        if (visible) count++;
      });
      this.querySelector('.ss-man-result-count').textContent = count + (count === 1 ? ' style' : ' styles');
      this.querySelector('.ss-man-empty').hidden = count !== 0;
      this.querySelector('.ss-man-scroll').scrollTop = 0;
    }
    updateBusy() {
      const busy = this.picker.getAttribute('aria-busy') === 'true';
      this.section.classList.toggle('ss-man-busy', busy);
      this.trigger.disabled = busy;
      if (busy) {
        savePersonalization(this.section);
        pendingFocus = this.dialog.open;
        this.close(false);
        this.feedback.hidden = false;
        this.feedback.textContent = 'Updating your charm…';
      } else if (this.section.getAttribute('data-variant-error') === 'true') {
        this.initialOptions.forEach(state => this.picker.querySelectorAll('input[type=radio]').forEach(input => {
          if (input.name === state.name) input.checked = input.value === state.value;
        }));
        this.feedback.hidden = false;
        this.feedback.textContent = 'We couldn’t update your choice. Please try again.';
      }
    }
  }
  customElements.define('ss-man-style-picker', ManStylePicker);
  document.addEventListener('soulyshine:variant:updated', event => sync(event.detail.picker));
  // Keep cart submission disabled while a new exact variant is being resolved.
  document.addEventListener('submit', event => {
    const section = event.target.closest('.ss-man-product');
    if (section?.querySelector('.ss-man-variant-picker[aria-busy=true]')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
})();
